import { getLocale } from "../runtime";

const sv_icondropdown = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rullgardinsmeny`
};

const icondropdown = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_icondropdown(inputs)
	return "iconDropdown";
};

export { icondropdown as "iconDropdown" };